export default __webpack_public_path__ + "static/media/E-commerce.72e7201c.png";